import { CustomHttpClient } from '../../providers/CustomHttpClient';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Cupom } from '../../model/cupom';
import { map } from 'rxjs/operators';
import { saveAs } from 'file-saver';
import { Observer } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RelatorioService {

  public cupons: Cupom[] = [];

  constructor(private http: CustomHttpClient, private httpClient: HttpClient) { }

  onConsulta(inicio: string, fim: string, tipoData: number, isRessarcimento: number) {
    return this.http.Get("api/relatorio/Get/" + inicio + "/" + fim + "/" + tipoData + "/" + isRessarcimento);
  }

  onBaixar(inicio: string, fim: string, tipoData: number, tipoArquivo: number, isRessarcimento: number) {
    window.open("api/relatorio/Download/" + inicio + "/" + fim + "/" + tipoData + "/" + tipoArquivo + "/" + isRessarcimento);
  }
}
